export default function ThemedPage({children}: {children: React.ReactNode}) {
  return <div style={{width: '100%'}}>{children}</div>;
}
